import { createContext, useContext } from 'react';

interface StepperContextType {
  currentStepIdx: number;
  nbSteps: number;
}

export const STEPPER_CONTEXT = createContext<StepperContextType | undefined>(
  undefined,
);

export function useStepperContext() {
  const context = useContext(STEPPER_CONTEXT);
  if (!context) {
    throw new Error('"useStepperContext" can only be used inside of a Stepper');
  }
  return context;
}
